module.exports = __webpack_public_path__ + "media/มอมอมอมอมอ.3228bc99.mp3";